import { Badge, Box, ButtonBase, styled } from "@mui/material";
import SupportAvatar from "../../SupportAvatar";
import { FC, Fragment, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import FlexBox from "../../FlexBox";
import { H6, Small, Tiny } from "../../Typography";
import PopoverLayout from "./PopoverLayout";

// styled components
const StyledSmall = styled(Small)(({ theme }) => ({
  display: "block",
  padding: "5px 1rem",
  cursor: "pointer",
  "&:hover": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.divider,
      ...theme.applyStyles("light", {backgroundColor: theme.palette.secondary.light})
  },
}));

const ProfilePopover: FC = () => {
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const userObj = JSON.parse(localStorage.getItem('user') || '{}');
  const userPicture = userObj.picture;
  const userName = userObj.name;

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('session');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userRole');
    setOpen(false);
    navigate('/');
  };

  return (
    <Fragment>
      <ButtonBase disableRipple ref={anchorRef} onClick={() => setOpen(true)}>
        <Badge
          overlap="circular"
          variant="dot"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{
            mr: 3,
            "& .MuiBadge-badge": {
              width: 11,
              height: 11,
              right: "7%",
              borderRadius: "50%",
              border: "2px solid #fff",
              backgroundColor: "success.main",
            },
          }}
        >
          <SupportAvatar
            src={userPicture || "/static/avatar/001-man.svg"}
            sx={{ width: 30, height: 30, ml: 1 }}
          />
        </Badge>
      </ButtonBase>

      <PopoverLayout
        hiddenViewButton
        maxWidth={230}
        minWidth={200}
        popoverOpen={open}
        anchorRef={anchorRef}
        popoverClose={() => setOpen(false)}
        title={
          <Box p={2}>
            <FlexBox alignItems="center">
              <SupportAvatar
                src={userPicture || "/static/avatar/001-man.svg"}
                sx={{ width: 35, height: 35 }}
              />

              <Box ml={1}>
                <H6>{userName}</H6>
                <Tiny display="block" fontWeight={500} color="text.disabled">
                </Tiny>
              </Box>
            </FlexBox>
          </Box>
        }
      >
        <Box p={2}>
          <StyledSmall onClick={handleLogout}>Log out</StyledSmall>
        </Box>
      </PopoverLayout>
    </Fragment>
  );
};

export default ProfilePopover;
